export const IS_LOADING = 'IS_LOADING';
export const COMMON_SET_USERINFO = 'COMMON_SET_USERINFO';
export const CLEAR_DATA = 'CLEAR_DATA';